export let DisplayStyle = {
  Standard: 'standard',
  Image: 'image'  
}